<template>
  <div v-if="loaded" class="grid-stack" ref="gridstack">
    <div
      v-for="(widget, widgetKey) in widgetsReady"
      :key="widgetKey"
      class="grid-stack-item"
      :class="{
        _autoHeight: widget.type == 'DataGrid',
        _inherited: widget.inherited,
        hidden: widgetKey.hidden
      }"
      :data-gs-x="widget.gsOptions.x"
      :data-gs-y="widget.gsOptions.y"
      :data-gs-width="widget.gsOptions.w"
      :data-gs-height="widget.gsOptions.h"
      :widget-id="widgetKey"
      :ref="'widget-' + widgetKey"
      :id="'widget' + widgetKey"
    >
      <LayoutWrapper class="grid-stack-item__wrapper" :layout="widget.layout">
        <span v-if="!widget.inherited" class="grid-stack-item__move">
          <icon name="arrows" />
        </span>
        <b-dropdown
          v-if="!widget.inherited && $can('update', 'Dashboard_' + currentDash)"
          size="lg"
          variant="link"
          toggle-class="text-decoration-none"
          no-caret
          class="grid-stack-item__actionsBtn"
          title="Actions"
        >
          <template v-slot:button-content>
            <icon name="ellipsis-v" />
          </template>
          <b-dropdown-item
            v-if="typeof widget.template !== 'undefined'"
            href="#"
            @click.prevent="editWidget(widgetKey)"
          >Edit</b-dropdown-item>
          <b-dropdown-item
            href="#"
            @click.prevent="removeWidget(widgetKey, widget.dependency)"
          >Delete</b-dropdown-item>
          <b-dropdown-item href="#" @click.prevent="changeTab(widgetKey)">Change Page</b-dropdown-item>
        </b-dropdown>
        <div
          class="grid-stack-item-content"
          :class="{
            [widget.classes]: widget.classes,
            '_hasTitle': widget.title
          }"
        >
          <div class="grid-stack-item__title" v-if="widget.title">
            <h4>{{ widget.title }}</h4>
          </div>
          <div v-if="typeof widget.template !== 'undefined'">
            <div
              v-if="
                (
                  toolsPanel_openedItemsDescription.editWidget &&
                  toolsPanel_openedItemsDescription.editWidget.key
                ) &&
                widgetKey === toolsPanel_openedItemsDescription.editWidget.key
              "
              class="gridEditorAutoSuggestParent"
            >
              <div class="templateWrapper" v-html="widget.template" @click="clickElement"></div>
            </div>

            <DynamicRender
              v-else
              :widget="widget"
              :widgetKey="widgetKey"
              :template="widget.template"
              :detailTemplate="widget.detailTemplate"
              :data="widgetsData"
              :computed="widgetsComputed"
            />
          </div>
          <div v-else>
            <DataGrid
              v-if="widget.type === 'DataGrid'"
              :widgetKey="widgetKey"
              :widgets="widgets"
              :tabs="tabs"
              :gridId="widget.props.gridId"
              :view="widget.props.view || ''"
              :inherited="widget.inherited || false"
              :extended="(Boolean(widget.props.extended) && widget.props.extended[widget.props.view])"
            />
          </div>
          <!-- <CustomCodeRender :customCode="getScopedCss(widget)" /> -->
        </div>
      </LayoutWrapper>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// components
import DynamicRender from '@/components/DynamicRender'
import CustomCodeRender from '@/components/CustomCodeRender'
import LayoutWrapper from './LayoutWrapper'
// helpers
import db from '@/services/db'
import gridstack from '@/helpers/gridstack'
import eventBus from '@/helpers/event-bus'

export default {
  props: {
    widgets: { type: Object, default: () => {} },
    tabs: { type: Array, default: () => [] },
    widgetsData: { type: Object, default: () => ({}) },
    widgetsComputed: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      loaded: false,
    }
  },
  components: {
    DynamicRender,
    CustomCodeRender,
    LayoutWrapper,
  },
  computed: {
    ...mapState([
      'currentTab',
      'currentSubTab',
      'currentDash',
      'widgetToUpdate',
      'activeToolbarItem',
      'toolbarItems',
      'fbUserModels',
      'fbWorkspaceData',
      'models_dashboardModel',
      'toolsPanel_openedItemsDescription',
      'toolsPanel_isOpened',
      'toolsPanel_visibleItem',
      'addedWidgetKey',
    ]),
    widgetsReady() {
      const widgetsReady = {}
      for (let widgetKey in this.widgets) {
        const widget = this.widgets[widgetKey]
        let allowed = true

        if (widget.tab !== this.currentTab) allowed = false
        if (this.currentSubTab && widget.subtab !== this.currentSubTab)
          allowed = false
        if (widget.subtab && !this.$route.query.subtab) allowed = false

        if (allowed) widgetsReady[widgetKey] = widget
      }

      if (this.addedWidgetKey) {
        const addedWidgetKey = this.addedWidgetKey
        for (let key in widgetsReady) {
          if (addedWidgetKey === key) {
            widgetsReady[key].hidden = true
            this.$nextTick(() => {
              gridstack.move(
                this.$refs['widget-' + key],
                this.widgets[key].gsOptions
              )
              gridstack.disableStatic()
            })
          }
          this.$store.commit('addedWidgetKey', '')
        }
      }

      return widgetsReady
    },
  },
  watch: {
    currentTab() {
      this.loaded = false

      this.$nextTick(() => {
        this.loaded = true
      })
    },
  },
  methods: {
    editWidget(key) {
      this.$store.commit('toolsPanel_setItem', {
        id: 'editWidget',
        payload: {
          key,
        },
      })
    },
    removeWidget(key, dependency) {
      let confirm = window.confirm('Are you sure?')
      if (!confirm) return
      this.$store.commit('addProcess', {
        process: 'deleteWidget',
        message: 'Deleting',
      })
      eventBus.$emit('removeWidget_eventBus', dependency)
      gridstack.destroyOne(this.$refs['widget-' + key])
      db.widgets.delete(key, dependency, () => {
        this.$store.commit('deleteProcess', 'deleteWidget')
        if (
          this.widgetToUpdate === key &&
          this.activeToolbarItem === this.toolbarItems[0]
        ) {
          this.$store.commit('removeActiveToolbarItem')
        }
      })
    },
    hideTitle(key) {
      let ref = 'title_' + key
      let el = this.$refs[ref]
      $(el)
        .find('.triggerHide')
        .hide()
      $(el)
        .find('.triggerShow')
        .show()
      $(el)
        .find('.titleContent')
        .hide()
    },
    showTitle(key) {
      let ref = 'title_' + key
      let el = this.$refs[ref]
      $(el)
        .find('.triggerHide')
        .show()
      $(el)
        .find('.triggerShow')
        .hide()
      $(el)
        .find('.titleContent')
        .show()
    },
    getJsonData(path) {
      path = path.slice(1).split('/')
      if (path) {
        let data = this.widgetsData
        for (let key of path) {
          if (!data[key]) {
            data = {}
            break
          }
          data = data[key]
        }
        return data
      } else {
        return this.widgetsData
      }
    },
    dataChanged(newData, path) {
      path = path.slice(1)
      db.widgets.updateDataByPath(path, newData, err => {
        if (err) {
          this.$store.commit('addError', err.message)
        }
      })
    },
    setGridStackItemAutoHeight(gs, gsi) {
      setTimeout(() => {
        const grid = $(gs).data('gridstack')
        const contentHeight =
          $(gsi)
            .find('.widgetContent > *')
            .get(0).clientHeight + 80
        const newHeight = Math.round(
          (contentHeight + grid.opts.verticalMargin) /
            (grid.cellHeight() + grid.opts.verticalMargin)
        )
        grid.update(gsi, null, null, null, newHeight)
      })
    },
    adjustAutoHeight() {
      const gs = this.$refs['gridstack']
      const gsItems = $(gs).find('.grid-stack-item._autoHeight')
      // gsItems.each((idx, gsItem) => {
      //   this.setGridStackItemAutoHeight(gs, gsItem)
      // })
    },
    getScopedCss(widget) {
      let styles = ''
      if (widget.styles) {
        const selectorTarget = `widget${widget['.key']} > .card`
        const mySelector = '#' + selectorTarget
        const mySelectorRegex = new RegExp(`\\.${selectorTarget}([ .#[:(]|$)`)
        const cssSelectorRegex = /[@.#a-zA-Z][^}]*?(?={)/g
        styles = widget.styles.replace(cssSelectorRegex, match => {
          // Match is a string of selectors like '.foo' or '.foo, #bar'
          // We need to split it on the comma and handle each selector individually
          return match
            .split(',')
            .map(selector => {
              selector = selector.trim()
              // Don't alter media queries, imports, or selectors that already contain '.mySelector'
              if (selector.startsWith('@') || selector.match(mySelectorRegex)) {
                return selector
              }
              // Prepend '.mySelector ' to the selector
              return mySelector + ' ' + selector
              // Combine the list of selectors back together
            })
            .join(',')
        })
        styles = styles.replace(
          /\*\s?{/gi,
          `#widget${widget['.key']} > .card *{`
        )
        styles = styles.replace(
          new RegExp(`#widget${widget['.key']} > .card body`, 'gi'),
          `#widget${widget['.key']} > .card`
        )
      }
      return { css: { [widget['.key']]: { name: 'scoped', code: styles } } }
    },
    clickElement: function(e) {
      //this.$refs.editPanel.handleClick();
      eventBus.$emit('elClick', e)
    },
    changeTab(tabKey) {
      eventBus.$emit('setTabForWidget', tabKey)
    },
  },
  mounted() {
    this.loaded = true

    this.$nextTick(() => {
      gridstack.init(
        this,
        this.$can('update', 'Dashboard_' + this.currentDash)
      )
    })
  },
  updated() {
    const { el } = gridstack.grid || {}
    if (!gridstack.grid || (el && el.parentNode)) {
      gridstack.update()
    }
  },
  beforeDestroy() {
    gridstack.destroy()
  },
}
</script>

<style lang="scss">
@import '~$scss/globals';
.grid-stack {
  min-height: 100px;
  padding-bottom: 50px;
  box-sizing: content-box;

  .widget {
    display: none;
  }
}
.card {
  margin-bottom: 0;
  -webkit-box-shadow: 0 0.25rem 0.5rem 0 rgba(136, 152, 170, 0.15) !important;
  box-shadow: 0 0.25rem 0.5rem 0 rgba(136, 152, 170, 0.15);
}

.grid-stack-item {
  position: relative;
  padding: 0 15px !important;
  &.hidden {
    display: none;
  }
  // .card,
  // .card-body {
  //   height: 100%;
  // }
  .card {
    margin-bottom: 0;
    -webkit-box-shadow: 0 0.25rem 0.5rem 0 rgba(136, 152, 170, 0.15);
    box-shadow: 0 0.25rem 0.5rem 0 rgba(136, 152, 170, 0.15) !important;
  }
  .card-body {
    padding: 15px;
  }
  &-content {
    position: relative;
    height: 100%;
    overflow-x: auto !important;
    &._hasTitle {
      padding-top: 57px;
      > div:last-child {
        height: 100%;
      }
    }
    &:not(._hasTitle) {
      > div:first-child {
        height: 100%;
      }
    }
    .widgetContent {
      height: 100%;
    }
  }
  &__title {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
  &__move {
    display: none;
    position: absolute;
    color: $color2;
    left: 7px;
    top: 3px;
    width: 20px;
    height: 20px;
    cursor: move;
    text-align: center;
    padding-top: 0px;
    z-index: 1;
  }
  &:hover .grid-stack-item__move {
    display: block;
  }
  &__wrapper {
    position: relative;
    overflow: auto;
    height: 100%;
    // z-index: 2001;
  }
  > .ui-resizable-handle {
    right: 19px !important;
    bottom: 4px !important;
  }
  &__actionsBtn {
    position: absolute !important;
    right: 10px;
    top: 2px;
    button {
      padding: 0 5px;
      z-index: 1;
    }
  }
  &._autoHeight {
    height: auto !important;
  }
}
.widgetsDataWrapper {
  padding-right: 20px;
}
.templateWrapper * {
  padding: 2px;
  //margin-left: unset;
  outline: 0.1px dashed #d5d5d5;
  min-height: 20px;
}
.templateWrapper .row {
  padding: 5px;
}
[mouseOn] {
  //background-color: #bcd5eb !important;
  outline: 2px solid #2fa4e7 !important;
}
[editSelected] {
  border: 2px solid #2fa4e7 !important;
}
</style>

